import { PureComponent } from 'react';

import Countdown from 'Component/Countdown';
import PromotionHero from 'Component/PromotionHero';
import AddToCart from 'Component/AddToCart';

import Link from 'Component/Link';
import Image from 'Component/Image';

import TextPlaceholder from 'Component/TextPlaceholder';
import ProductPrice from 'Component/ProductPrice';

//import placeholderImg from '../../../public/assets/images/beauty-advent-calendar/beauty-advent-placeholder.png';
import placeholderImg from './img/image.png';
import adventLogo from '../../../public/assets/images/beauty-advent-calendar/advent-icon.png';
//import adventSticker from '../../../public/assets/images/beauty-advent-calendar/label-advent-2023.png';
import adventSticker from './img/label_advent_2024-galben.png';
//import adventStickerExpired from '../../../public/assets/images/beauty-advent-calendar/label-advent-2023-expired.png';
import adventStickerExpired from './img/zile_trecute_label_advent_2023.png';

import './BeautyAdventCalendarPage.style';

export class BeautyAdventCalendarPage extends PureComponent {
    scrollToActiveDay = () => {
        const elemActiveDay = document.querySelector('.advent-content.isActive');

        if (!elemActiveDay) return;

        let offset = 0;
        if (window.innerWidth >= 1366) {
            offset = 200;
        } else if (window.innerWidth <= 767) {
            offset = 400;
        }

        window.scrollTo({
            top: elemActiveDay.getBoundingClientRect().top + window.scrollY - offset,
            behavior: 'smooth'
        });
    }

    renderHero() {
        const { isLoading, data: { hero: { title, subtitle, background, image } = {} } } = this.props;

        if (isLoading) {
            return <div block="BeautyAdventCalendarPage" elem="HeroLoading" />;
        }

        if (!title) {
            return null;
        }

        return (
            <PromotionHero
                renderType="view"
                title={ title }
                subtitle={ subtitle }
                background_color={ background }
                background_image={ image }
                text_color = "#FFFFFF"
            />
        );
    }

    renderTimer() {
        const { isLoading, data: { endDate }, handleCountdownExpired } = this.props;

        if (isLoading) {
            return (
                <div block="BeautyAdventCalendarPage" elem="TimerContainer">
                    <div block="BeautyAdventCalendarPage" elem="TimerLoading" />
                </div>
            )
        }

        return (
            <div block="BeautyAdventCalendarPage" elem="TimerContainer">
                <div block="BeautyAdventCalendarPage" elem="Timer">
                    <span block="BeautyAdventCalendarPage" elem="TimerTitle">{__("THE PRODUCT OF THE DAY IS ACTIVE")}</span>
                    <Countdown date={ endDate } />
                    <button block="BeautyAdventCalendarPage" elem="GoToActiveDay" onClick={ this.scrollToActiveDay }>{__('Go to the product of the day!')}</button>
                </div>
            </div>
        )
    }

    renderProducts() {
        const { isLoading, data: { products = [] } = { } } = this.props;

        if (isLoading) {
            return (
                <div block="BeautyAdventCalendarPage" elem="Container">
                    <div block="BeautyAdventCalendarPage" elem="Products">
                        { Array.from({ length: 24 }, (_, i) => this.renderPlaceholder(++i))}
                    </div>
                </div>
            )
        }

        if (!products.length) {
            return null;
        }

        return (
            <div block="BeautyAdventCalendarPage" elem="Container">
                <div block="BeautyAdventCalendarPage" elem="Products">
                    { products.map((product, index) => {
                        const { activeDay } = product;
                        const today = new Date();

                        if (activeDay <= today.getDate()) {
                            return this.renderActive(product, ++index, activeDay == today.getDate());
                        }

                        return this.renderPlaceholder(++index);
                    }) }
                </div>
            </div>
        )
    }

    renderExpired(product, index) {
        const { name, url, small_image: { url: imageUrl } } = product;

        return (
            <div block="BeautyAdventCalendarPage" elem="Col" key={ index }>
                <Link to={ url } block="BeautyAdventCalendarPage" elem="Product">
                    <div className="advent-content">
                        <div block="BeautyAdventCalendarPage" elem="Expired">
                            <Image className="advent-logo" src={ adventLogo } alt={ name } ratio="custom" />
                            <Image className="product-image" src={ imageUrl } alt={ name } ratio="custom" />
                            <h2>{ name }</h2>
                            <span className="index-number">{ index }</span>
                            <p></p>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    renderProductPrice(priceRange, cartRuleSpecialPrice) {
        if (!priceRange) {
            return <div><TextPlaceholder /></div>;
        }

        return (
            <ProductPrice
                price={ priceRange }
                cartRuleSpecialPrice = { cartRuleSpecialPrice }
                mix={ { block: 'BeautyAdventCalendarPage', elem: 'Price' } }
            />
        );
    }

    renderActive(product, index, isActive) {
        const { name, url, small_image: { url: imageUrl }, calendarDiscountPercent, price_range, cart_rule_special_price } = product;
        const { data : {sticker_background, sticker_color } = {}} = this.props;

        const contentClassName = isActive ? 'advent-content isActive' : 'advent-content';
        const labelSticker = isActive ? adventSticker : adventStickerExpired;

        return (
            <div block="BeautyAdventCalendarPage" elem="Col" key={ index }>
                <Link to={ url } block="BeautyAdventCalendarPage" elem="Product">
                    <div block="BeautyAdventCalendarPage" elem="Active">
                        <div className={contentClassName}>
                            <Image className="sticker-logo" src={ labelSticker } alt={ name } ratio="custom" />
                            <div block="BeautyAdventCalendarPage" elem="Sticker" style={ sticker_background && sticker_color ? {backgroundColor: sticker_background, color: sticker_color} : null }>{ `-${calendarDiscountPercent}%` }</div>
                            <Image className="product-image" src={ imageUrl } alt={ name } ratio="custom" />
                            <h2>{ name }</h2>
                            { this.renderProductPrice(price_range, cart_rule_special_price) }
                            <div block="BeautyAdventCalendarPage" elem="AddToCartButtonContainer">
                                { this.renderAddToCart(product) }
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    renderAddToCart(product) {
        return (
            <AddToCart
                product={ product }
                configurableVariantIndex={ -1 }
                mix={ { block: 'Button_isHollow' } }
                quantity={ 1 }
                groupedProductQuantity={{ }}
                productOptionsData={{ requiredOptions: [] }}
            />
        );
    }

    renderPlaceholder(index) {
        return (
            <div block="BeautyAdventCalendarPage" elem="Col" key={ index }>
                <div block="BeautyAdventCalendarPage" elem="Product">
                    <div block="BeautyAdventCalendarPage" elem="Placeholder">
                        <img src={placeholderImg} />
                        <span className="index-number">{ index }</span>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div block="BeautyAdventCalendarPage">
                { this.renderHero() }
                { this.renderTimer() }
                { this.renderProducts() }
            </div>
        );
    }
}

export default BeautyAdventCalendarPage;
